import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Table from '../Table';
import TableHead from '../TableHead';
import TableBody from '../TableBody';
import TableRow from '../TableRow';
import TableCell from '../TableCell';
import useMediaQuery, { CONSULTA_MOVIL } from '../../utils/useMediaQuery';

/**
 * PARCHE CABSEN (2026-09-14): en movil la tabla de series de cuatro columnas parte las cabeceras a
 * mitad de palabra ("Descripc-ion"); se sustituye por una lista con una entrada por serie.
 */
const ListaDeSeries = ({ seriesTableColumns, seriesTableDataSource }) => {
  const { t } = useTranslation('StudyList');
  return (
    <ul className="mt-4 flex flex-col gap-2 text-lg text-white">
      {seriesTableDataSource.map((serie, i) => (
        <li
          key={i}
          className="border-secondary-light border-b pb-2 last:border-b-0"
        >
          <div className="break-words">{serie.description}</div>
          <div className="text-secondary-light">
            {seriesTableColumns.seriesNumber} {serie.seriesNumber} · {serie.modality} ·{' '}
            {serie.instances}{' '}
            {t(String(serie.instances) === '1' ? 'Instance' : 'Instances').toLowerCase()}
          </div>
        </li>
      ))}
    </ul>
  );
};

ListaDeSeries.propTypes = {
  seriesTableDataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  seriesTableColumns: PropTypes.object.isRequired,
};

const StudyListExpandedRow = ({ seriesTableColumns, seriesTableDataSource, children }) => {
  // PARCHE CABSEN (2026-09-14): en movil menos sangria (12 px) para aprovechar el ancho, y la
  // tabla de series se pinta como lista (ver ListaDeSeries)
  const esMovil = useMediaQuery(CONSULTA_MOVIL);
  if (esMovil) {
    return (
      <div className="w-full bg-black py-4 pl-3 pr-3">
        <div className="block">{children}</div>
        <ListaDeSeries
          seriesTableColumns={seriesTableColumns}
          seriesTableDataSource={seriesTableDataSource}
        />
      </div>
    );
  }
  return (
    <div className="w-full bg-black py-4 pl-12 pr-2">
      <div className="block">{children}</div>
      <div className="mt-4">
        <Table>
          <TableHead>
            <TableRow>
              {Object.keys(seriesTableColumns).map(columnKey => {
                return <TableCell key={columnKey}>{seriesTableColumns[columnKey]}</TableCell>;
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {seriesTableDataSource.map((row, i) => (
              <TableRow key={i}>
                {Object.keys(row).map(cellKey => {
                  const content = row[cellKey];
                  return (
                    <TableCell
                      key={cellKey}
                      className="truncate"
                    >
                      {content}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

StudyListExpandedRow.propTypes = {
  seriesTableDataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  seriesTableColumns: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default StudyListExpandedRow;
